import { installIosWebViewBridgeShim } from './iosWebViewBridge';

installIosWebViewBridgeShim();
